import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
export const revenueOpportunitiesSummaryKey = (businessId)=>[
        QueryKeys.PulseOpportunities,
        businessId
    ];
export const revenueOpportunitiesListKey = (businessId, query)=>[
        ...revenueOpportunitiesSummaryKey(businessId),
        'list',
        query
    ];
